'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { CardDashboardError } from '@/components/common/Card/CardDashboard';
const ChartMyBorrowError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardDashboardError message="Something went wrong while loading My Borrow chart." />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(ChartMyBorrowError);